module.exports = __webpack_public_path__ + "71e7a54a85eb3973b33cd3fe4728271b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/images/pages/pipi_portrait.jpg
// module id = 41
// module chunks = 0